import Cropper from "cropperjs";
export default {
  data() {
    var src_url = this.$route.context.src_url;
    console.log(src_url);
    return {
      src_url: src_url,
      cropper: null
    };
  },

  mounted() {},

  on: {
    pageAfterIn: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var image = $$("#croppable-image-img")[0];
      self.cropper = new Cropper(image, {
        aspectRatio: 1,
        viewMode: 1
      });
    },
    pageBeforeOut: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.cropper.destroy();
      self.cropper = null;
    }
  },
  methods: {
    savePicture: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var canvas = self.cropper.getCroppedCanvas({
        width: 512,
        height: 512
      });
      var imageValue = canvas.toDataURL('image/jpeg', 0.8);
      self.$app.request({
        url: Url.to("user/profile-picture-multi-db"),
        method: "POST",
        data: {
          image: imageValue
        },
        success: function (data, status, xhr) {
          window.identity['image_thumb_url'] = imageValue; //self.user.image_thumb_url = window.identity['image_thumb_url'];
          //self.$update();

          window.reloadIdentity();
          self.$app.dialog.alert('Profile picture updated successfully', function () {});
          app.views.current.router.back("/account-panel/", {
            force: true
          });
        }
      });
    }
  },
  id: '7256163e27',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="profile-picture">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Profile Picture</div>\n            </div>\n        </div>\n        <div class="page-content no-padding-bottom">\n            <div class="img-container" style="height: calc(100% - 100px)">\n                <img id="croppable-image-img" src="';
      r += c(ctx_1.src_url, ctx_1);
      r += '" class="width-100" style="display:block;max-width: 100%;max-height: 100%;object-fit: contain" />\n            </div>\n            <div class="block">\n                <button @click="savePicture" class="button button-large button-fill">Save</button>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};